import styled from "styled-components";
import Theme from "../../../styles/Theme/Theme";

export const Text = styled.p`
   margin: 0;
   margin-right: ${props => (props.marginRight ? props.marginRight : null)};
   margin-left: ${props => (props.marginLeft ? props.marginLeft : null)};
   margin-bottom: ${props => (props.marginBottom ? props.marginBottom : null)};
   color: ${props => (props.color ? props.color : null)};
   font-weight: ${props => (props.fontWeight ? props.fontWeight : null)};

   font-size: ${props => (Theme.typography.fontSize[props.fontSize + '_mobile'])};

   @media ${Theme.devices.tablet} {
      font-size: ${props => (Theme.typography.fontSize[props.fontSize + '_tablet'])}
   }

   @media ${Theme.devices.desktop} {
      font-size: ${props => (Theme.typography.fontSize[props.fontSize + '_desktop'])}
   }

   @media ${Theme.devices.videowall} {
      font-size: ${props => (Theme.typography.fontSize[props.fontSize + '_videowall'])}
   }
`;